<template>
    <home endpoint="faretype" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'faretype',
  components: {
    home,
  },
  data () {
    return {
      params: {
        fields: [
          {name: 'id', label: 'Código', required: true},
          {name: 'Name', label: 'Nombre', required: true},
          {name: 'Closed', label: 'Cerrado', editor: 'checkbox'}],
        title: 'Tipos de Tarifas',
        title2: 'Tipos de Tarifa'
      }
    }
  },
}
</script>

